import { FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { IListClientsResponse } from "../model/sdp/base/list-clients-response";
import ApplicationAppService from "../application/platform/application-app-service";
import AuthenticatorAppService from "../application/platform/security/authenticator-app-service";

export interface DefaultSelectClientProps {
    handleOnChange?: (e: any) => void;
    clientId?: number | undefined;
    required: boolean;
    disabled?: boolean;
    // Mensagem de validação exibida abaixo do campo (substitui o destaque automático de "required")
    error?: string | false;
}

const SELECT_NAME = 'select-client';

async function listClientsSafely(clientId?: number): Promise<IListClientsResponse[]> {
    try {
        return await AuthenticatorAppService.listClients(clientId);
    } catch {
        return [];
    }
}

export default function DefaultSelectClient(props: DefaultSelectClientProps) {
    const authenticationData = ApplicationAppService.getAuthenticationData();
    const [clients, setClients] = useState<IListClientsResponse[]>([]);
    const [internalClientId, setInternalClientId] = useState<string>(authenticationData?.type === 1 ? authenticationData.company.id.toString() : "");
    // Sempre a versão mais recente do callback: os efeitos assíncronos não podem usar uma closure antiga
    const onChangeRef = useRef(props.handleOnChange);
    onChangeRef.current = props.handleOnChange;
    const internalClientIdRef = useRef(internalClientId);
    internalClientIdRef.current = internalClientId;

    function notify(value: number | string | undefined) {
        onChangeRef.current?.({ target: { name: SELECT_NAME, value } });
    }

    function handleOnChange(e: any) {
        notify(e.target.value);
        setInternalClientId(e.target.value);
    }

    useEffect(() => {
        (async () => {
            if (props.clientId !== undefined && props.clientId.toString() !== internalClientIdRef.current) {
                setClients(await listClientsSafely(props.clientId));
                setInternalClientId(props.clientId.toString());
            }
            notify(props.clientId);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.clientId]);

    useEffect(() => {
        (async () => {
            setClients(await listClientsSafely(undefined));
            notify(internalClientIdRef.current);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isEmpty = !internalClientId;
    const hasError = props.error !== undefined ? !!props.error : props.required && isEmpty;

    return (
        <React.Fragment>
            <InputLabel required={props.required}>Entidade</InputLabel>
            <Select
                name={SELECT_NAME}
                onChange={handleOnChange}
                fullWidth
                disabled={!!props.disabled}
                error={hasError}
                value={internalClientId}
            >
                {clients.length > 1 && (
                    <MenuItem value="">
                        <em>Selecionar</em>
                    </MenuItem>
                )}
                {clients.map((client) => (
                    <MenuItem value={client.id.toString()} key={client.id}>{client.name} - {client.formattedDocument}</MenuItem>
                ))}
            </Select>
            {props.error && <FormHelperText error>{props.error}</FormHelperText>}
        </React.Fragment>
    );
}
